import { render } from "./FrmPredefinidoCreate.vue?vue&type=template&id=4d95c96b&scoped=true"
import script from "./FrmPredefinidoCreate.vue?vue&type=script&lang=js"
export * from "./FrmPredefinidoCreate.vue?vue&type=script&lang=js"

import "./FrmPredefinidoCreate.vue?vue&type=style&index=0&id=4d95c96b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d95c96b"]])

export default __exports__